import { Rule } from "../../types";

export function evaluateRules(
	rules: Rule[] = [],
	formValues: Record<string, any>
): Set<number> {
	const visible = new Set<number>();
	for (const rule of rules) {
		const matches = rule.when.every((cond) => {
			const current = formValues[String(cond.field_key)];
			if (cond.operator === "eq") {
				return current === cond.value;
			}
			return false;
		});
		if (matches) {
			rule.then.show?.forEach((k) => visible.add(k));
		}
	}
	return visible;
}
export function getRuleTargets(rules: Rule[] = []): Set<number> {
	const targets = new Set<number>();
	for (const r of rules) {
		r.then?.show?.forEach((k) => targets.add(k));
	}
	return targets;
}